// SetupChecklist.js
// Hero-slot card for a teacher with no classes yet: Add students -> Create a
// test -> Plan a lesson (lesson step only when the caller includes it, i.e.
// the lesson_plan flag is on). Each step shows a check icon when done.
//
// Renders its own rows instead of HomeRow: HomeRow's icon is always drawn in
// a fixed neutral color, but a done/pending step needs two distinguishable
// icon colors (green check vs. muted circle), which HomeRow's props don't
// expose (primitives are frozen for this package).
// See docs/superpowers/specs/2026-09-16-home-redesign.md §5.
import React from "react";
import { View, Text, Pressable, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import HomeCard from "../primitives/HomeCard";
import { HOME, homeColors } from "../homeTheme";

const identity = (s) => s;

const SetupChecklist = ({ steps = [], isDarkMode = false, t = identity }) => {
  const colors = homeColors(isDarkMode);

  return (
    <HomeCard
      title={t("Set up your class")}
      hero
      isDarkMode={isDarkMode}
      testID="setup-checklist"
    >
      {steps.map((step, index) => {
        const Row = step.onPress ? Pressable : View;
        return (
          <Row
            key={step.label}
            testID={`setup-checklist-row-${index}`}
            onPress={step.onPress || undefined}
            style={[
              styles.row,
              { borderTopWidth: index === 0 ? 0 : 1, borderTopColor: colors.line },
            ]}
          >
            <MaterialCommunityIcons
              name={step.done ? "check-circle" : "circle-outline"}
              size={18}
              color={step.done ? colors.green : colors.ink3}
            />
            <Text style={[styles.label, { color: colors.textPrimary }]}>{step.label}</Text>
          </Row>
        );
      })}
    </HomeCard>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    paddingVertical: HOME.rowPadY,
  },
  label: { fontSize: HOME.titleSize, fontWeight: "600" },
});

export default SetupChecklist;
